import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiTarget,FiClock,FiUsers,FiStar,FiZap,FiCalendar}=FiIcons;

const FinalCTA=()=> {
  return (
    <section className="py-20 px-4 relative">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-purple-900/20 to-transparent"></div>
      <div className="relative z-10 max-w-6xl mx-auto">
        <motion.div
          initial={{y: 30,opacity: 0}}
          whileInView={{y: 0,opacity: 1}}
          transition={{duration: 0.8}}
          viewport={{once: true}}
          className="text-center mb-16"
        >
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6">
            <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
              จองที่นั่งเลย ตอนนี้
            </span>
          </h2>
          <h3 className="text-3xl md:text-4xl font-bold text-white mb-8">
            อ่านคนขาด... ชนะทุกเกมความสัมพันธ์
          </h3>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            ราคาพิเศษ ก่อนปรับราคา
          </p>
        </motion.div>

        <div className="max-w-4xl mx-auto">
          {/* Main CTA Box */}
          <motion.div
            initial={{scale: 0.9,opacity: 0}}
            whileInView={{scale: 1,opacity: 1}}
            transition={{duration: 0.8}}
            viewport={{once: true}}
            className="relative overflow-hidden"
          >
            {/* Animated Background */}
            <div className="absolute inset-0 bg-gradient-to-r from-purple-500/20 via-pink-500/20 to-red-500/20 rounded-3xl"></div>
            <div className="absolute inset-0 bg-gradient-to-br from-transparent via-purple-500/10 to-transparent rounded-3xl animate-pulse"></div>
            <div className="relative bg-slate-800/60 backdrop-blur-lg border border-purple-500/50 rounded-3xl p-10 shadow-2xl">
              
              {/* Special Offer Banner */}
              <div className="bg-gradient-to-r from-yellow-500/20 via-orange-500/20 to-red-500/20 border-2 border-yellow-500/50 rounded-2xl p-6 mb-8 text-center">
                <h4 className="text-2xl md:text-3xl font-bold text-yellow-300 mb-4">
                  🔥 ราคาพิเศษ สำหรับ 20 คนแรก 🔥
                </h4>
                <p className="text-lg text-white mb-2">
                  หรือ เฉพาะจองและโอนเงินเต็มจำนวนภายในวันที่ 21 ธ.ค. 2568 นี้
                </p>
                <div className="text-3xl md:text-4xl font-bold text-orange-400 mt-4">
                  ราคาพิเศษเพียง <span className="text-yellow-300">9,995.-</span>
                </div>
              </div>

              {/* Course Title */}
              <div className="text-center mb-8">
                <h4 className="text-3xl md:text-4xl font-bold text-white mb-4">
                  จองที่นั่งเลย ตอนนี้
                </h4>
              </div>

              {/* Key Features */}
              <div className="grid md:grid-cols-3 gap-6 mb-10">
                <div className="text-center">
                  <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full flex items-center justify-center mx-auto mb-3">
                    <SafeIcon icon={FiTarget} className="text-2xl text-white" />
                  </div>
                  <h5 className="font-semibold text-white mb-2">อ่านคนแม่นยำ</h5>
                  <p className="text-gray-300 text-sm">ขาดทะลุถึงกระดูก</p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-gradient-to-br from-pink-500 to-red-500 rounded-full flex items-center justify-center mx-auto mb-3">
                    <SafeIcon icon={FiStar} className="text-2xl text-white" />
                  </div>
                  <h5 className="font-semibold text-white mb-2">โบนัสครบชุด</h5>
                  <p className="text-gray-300 text-sm">มูลค่ากว่า 22,800 บาท</p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-gradient-to-br from-red-500 to-orange-500 rounded-full flex items-center justify-center mx-auto mb-3">
                    <SafeIcon icon={FiZap} className="text-2xl text-white" />
                  </div>
                  <h5 className="font-semibold text-white mb-2">เปลี่ยนชีวิตทันที</h5>
                  <p className="text-gray-300 text-sm">ใช้ได้ตลอดชีวิต</p>
                </div>
              </div>

              {/* Main CTA Button */}
              <div className="text-center mb-8">
                <button className="group relative px-12 py-6 bg-gradient-to-r from-purple-600 via-pink-600 to-red-600 text-white font-bold text-2xl rounded-full shadow-2xl hover:shadow-purple-500/30 transition-all duration-300 transform hover:scale-105 border border-purple-400/50">
                  <span className="relative z-10">🔥 สมัครทันที! Bazi Love & Relationships</span>
                  <div className="absolute inset-0 bg-gradient-to-r from-purple-700 via-pink-700 to-red-700 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  {/* Animated Ring */}
                  <div className="absolute inset-0 rounded-full border-2 border-white/30 animate-ping"></div>
                </button>
                <div className="mt-6">
                  <p className="text-3xl font-bold text-purple-400 mb-2">
                    ราคาพิเศษ 9,995.-
                  </p>
                  <p className="text-gray-300">
                    ลดจาก <span className="line-through text-red-400">37,300 บาท</span> เหลือเพียง 9,995 บาท
                  </p>
                </div>
              </div>

              {/* Course Details */}
              <div className="grid md:grid-cols-2 gap-6 text-center">
                <div className="bg-slate-700/30 rounded-xl p-4">
                  <SafeIcon icon={FiCalendar} className="text-2xl text-purple-400 mx-auto mb-2" />
                  <h6 className="font-semibold text-white mb-1">วันเรียน</h6>
                  <p className="text-gray-300">21-22 กุมภาพันธ์ 2569</p>
                  <p className="text-gray-400 text-sm">(เสาร์-อาทิตย์)</p>
                </div>
                <div className="bg-slate-700/30 rounded-xl p-4">
                  <SafeIcon icon={FiUsers} className="text-2xl text-pink-400 mx-auto mb-2" />
                  <h6 className="font-semibold text-white mb-1">จำนวนที่นั่ง</h6>
                  <p className="text-gray-300">จำกัด 20 ท่านเท่านั้น</p>
                  <p className="text-gray-400 text-sm">เพื่อการดูแลทั่วถึง</p>
                </div>
              </div>

              {/* Urgency Elements */}
              <div className="mt-8 text-center">
                <div className="bg-gradient-to-r from-red-500/20 to-orange-500/20 border border-red-500/30 rounded-xl p-4">
                  <div className="flex items-center justify-center mb-2">
                    <SafeIcon icon={FiClock} className="text-red-400 mr-2" />
                    <span className="text-red-400 font-semibold">เหลือเวลาจำกัด!</span>
                  </div>
                  <p className="text-white font-medium">
                    ราคาพิเศษนี้สำหรับ 20 ท่านแรกเท่านั้น หรือจนกว่าจะปรับราคา
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Testimonial Quote */}
          <motion.div
            initial={{y: 30,opacity: 0}}
            whileInView={{y: 0,opacity: 1}}
            transition={{duration: 0.8,delay: 0.3}}
            viewport={{once: true}}
            className="mt-12 text-center"
          >
            <div className="bg-slate-800/40 backdrop-blur-sm border border-slate-700/50 rounded-2xl p-6 max-w-3xl mx-auto">
              <blockquote className="text-lg md:text-xl text-gray-300 italic mb-4">
                "การลงทุนในการเรียนรู้การอ่านคน คือการลงทุนที่คุ้มค่าที่สุดในชีวิต เพราะคุณจะใช้มันได้ทุกวัน ทุกความสัมพันธ์ และตลอดชีวิต"
              </blockquote>
              <cite className="text-purple-400 font-semibold">- อ.รวิ</cite>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;